import AuctionRoomBookingIcon from '@material-ui/icons/Event';
import { resourceWrapper } from '../../Components/ui/utils';
import { ResourcePermissions } from '../../Providers/AppPermissionsProvider';
import { ResourceExport } from '../../types/resource-export.type';
import AuctionRoomBookingDetails from './AuctionRoomBookingDetails';
import AuctionRoomBookingList from './AuctionRoomBookingList';

export const AUCTION_ROOM_BOOKING_PERMISSIONS: ResourcePermissions = {
  canEdit: [],
  canShow: [],
  canCreate: [],
  canList: [],
};

const AuctionRoomBooking: ResourceExport = {
  list: AuctionRoomBookingList,
  create: resourceWrapper(
    'create',
    AuctionRoomBookingDetails,
    undefined,
    undefined,
    AUCTION_ROOM_BOOKING_PERMISSIONS,
  ),
  edit: resourceWrapper(
    'edit',
    AuctionRoomBookingDetails,
    undefined,
    undefined,
    AUCTION_ROOM_BOOKING_PERMISSIONS,
  ),
  show: resourceWrapper(
    'show',
    AuctionRoomBookingDetails,
    undefined,
    undefined,
    AUCTION_ROOM_BOOKING_PERMISSIONS,
  ),
  icon: AuctionRoomBookingIcon,
};

export default AuctionRoomBooking;
